import React from "react";
import { Link } from "react-router-dom";
import { Search, ShoppingBag, User } from "lucide-react";

const iconBtn = "text-[#EAE3D8] hover:text-white transition-colors";

export const CurrencySelect = ({ currency, setCurrency, currencies }) => (
  <select
    value={currency} onChange={(e) => setCurrency(e.target.value)} data-testid="currency-select" dir="ltr"
    className="bg-transparent text-xs uppercase tracking-[0.1em] text-[#EAE3D8] hover:text-white transition-colors border border-[#4A4A46] px-2 py-1 outline-none cursor-pointer"
  >
    {currencies.map((c) => <option key={c} value={c} className="bg-[#141311] text-[#F2EBE1]">{c}</option>)}
  </select>
);

export const HeaderIcons = ({ count, onSearch, onCart }) => (
  <>
    <button onClick={onSearch} data-testid="search-open" aria-label="Search" className={iconBtn}>
      <Search size={19} strokeWidth={1.4} />
    </button>
    <Link to="/account" data-testid="account-link" className={`${iconBtn} hidden sm:block`}>
      <User size={19} strokeWidth={1.4} />
    </Link>
    <button onClick={onCart} data-testid="cart-open" aria-label="Cart" className={`relative ${iconBtn}`}>
      <ShoppingBag size={19} strokeWidth={1.4} />
      {count > 0 && (
        <span data-testid="cart-count" className="absolute -top-2 -end-2 bg-[#C49A6C] text-[#0B0A08] text-[10px] w-4 h-4 flex items-center justify-center font-medium">
          {count}
        </span>
      )}
    </button>
  </>
);
